import React, {Component} from 'react';
import axios from 'axios';
import {  withRouter } from "react-router-dom";
import auth0Client from '../Auth';
import {ToastContainer, ToastStore} from 'react-toasts';
import {SERVER_URL}  from '../Constants';
import "react-datepicker/dist/react-datepicker.css";

  

class ClaimShipment extends Component {
    constructor(props) {
      super(props);

        this.state = {

            fromAddress:'',
            fromAddress2:'',
            fromCity:'',
            fromState:'',
            fromPostalCode:'',
            fromCountry:'',

            toAddress:this.props.claim.shippingAddress,
            toAddress2:this.props.claim.shippingAddress2,
            toCity:this.props.claim.shippingCity,
            toState:this.props.claim.shippingState,
            toPostalCode:this.props.claim.shippingPostalCode,
            toCountry:this.props.claim.shippingCountry,

            widthInInches : 10.0,
            heightInInches : 10.0,
            lengthInInches : 10.0,
            weightInOunces : 12.0,
            
           showSuccess:false
                
               

            }
        }
   

    renderToast=()=>{
        return <div>
           <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
        </div>
    };


    componentDidMount(){
        // load the venue address
        axios.get(`${SERVER_URL}/venue/` + auth0Client.getActiveVenuedId(),{
            headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}` }
          }).then((res)=>{
            const venue = res.data;
            this.setState({
              name: venue.name,
              active:venue.active,
              publishId:venue.publishId,
              venueDescription:venue.venueDescription,
                fromAddress: venue.shippingAddress,
                fromAddress2: venue.shippingAddress2,
                fromCity: venue.shippingCity,
                fromState: venue.shippingState,
                fromPostalCode: venue.shippingPostalCode,
                fromCountry: venue.shippingCountry,
                       

              

              disabled:false
            });
          }).catch((e)=>{ 
            //console.log("error " + e)
            ToastStore.error("An error occured. Please try again. error: " + e.message);
          });
      
    }

    sendShipRequest=async()=>{
        // Validate 
        if (!this.validateForShip()) { return;}

        await axios.post(`${SERVER_URL}/Shipping/RequestShipping`, {
            claim : this.props.claim,
            fromAddress:this.state.fromAddress,
            fromAddress2:this.state.fromAddress2,
            fromCity:this.state.fromCity,
            fromState:this.state.fromState,
            fromPostalCode:this.state.fromPostalCode,
            fromCountry:this.state.fromCountry,

            toAddress:this.state.toAddress,
            toAddress2:this.state.toAddress2,
            toCity:this.state.toCity,
            toState:this.state.toState,
            toPostalCode:this.state.toPostalCode,
            toCountry:this.state.toCountry,

            widthInInches : this.state.widthInInches,
            heightInInches : this.state.heightInInches,
            lengthInInches : this.state.lengthInInches,
            weightInOunces : this.state.weightInOunces,
        }, {
            headers: { 
              'Authorization': `Bearer ${auth0Client.getIdToken()}`,
              'venueId': auth0Client.getActiveVenuedId()
            
            }
          })
          .then((res)=>{
            if (res.status!==200){
              
              ToastStore.error("An error occured during the request for the shipping label from the customer.  Support will review the logs.  Please try again.");
            }else{
              ToastStore.success('Request sent Successfully!');
            }
              //this.props.history.push('/');
              // Show saved successful
              this.setState({
                showAlert:false,
                disabled: false,
                showSuccess: true,
        
            })
            if (this.props.refreshParent){
              this.props.refreshParent();
            }
            
          })
          .catch ((e)=>{
              console.error(e);
              this.setState({
                  showAlert:true,
                  disabled: false,
                  error:e,
        
              })
              ToastStore.error(this.state.error.response.data);
        
          })
       



    }
    handleInputChange=(event) =>{
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        this.setState({
          [name]: value
        });
      }

    validateForShip=()=>{

        // check the short Description
        if (!this.props.claim.lastName) {ToastStore.error('Missing Last Name'); return false;}
        // check long description
        if (!this.props.claim.firstName) {ToastStore.error('Missing First Name'); return false;}
        // check Email
        if (!this.props.claim.email) {ToastStore.error('Missing Email'); return false;}
        // check ship address
        if (!this.state.fromAddress) {ToastStore.error('Missing shipping Address'); return false;}
        // check ship city
        if (!this.state.fromCity) {ToastStore.error('Missing shipping City'); return false;}
        // check ship State
        if (!this.state.fromState) {ToastStore.error('Missing shipping State'); return false;}
        // check ship postal
        if (!this.state.fromPostalCode) {ToastStore.error('Missing shipping Postal Code'); return false;}
        // check ship country
        if (!this.state.fromCountry) {ToastStore.error('Missing shipping Country'); return false;}
  
        // SHIP TO Address
        if (!this.state.toAddress) {ToastStore.error('Missing TO shipping Address'); return false;}
        // check ship city
        if (!this.state.toCity) {ToastStore.error('Missing TO shipping City'); return false;}
        // check ship State
        if (!this.state.toState) {ToastStore.error('Missing TO shipping State'); return false;}
        // check ship postal
        if (!this.state.toPostalCode) {ToastStore.error('Missing TO shipping Postal Code'); return false;}
        // check ship country
        if (!this.state.toCountry) {ToastStore.error('Missing TO shipping Country'); return false;}
    
        // dimensions

        if (!this.state.widthInInches){ToastStore.error('Missing Width Dimension'); return false;}
        if (!this.state.heightInInches){ToastStore.error('Missing Height Dimension'); return false;}
        if (!this.state.lengthInInches){ToastStore.error('Missing Length Dimension'); return false;}
        if (!this.state.weightInOunces){ToastStore.error('Missing Weight '); return false;}
      
      
        return true;
  
  
    }

renderSuccess=()=>{
  return (

    <div className='alert alert-dismissible alert-success'>
      <h5> Request sent to customer. </h5> <h6>The claim has been updated to "Label Requested"</h6>

    </div>


  )
}


render(){
  return (this.state.showSuccess) ? this.renderSuccess() : this.renderCreateRequest();
}



renderCreateRequest(){

      

      return(

      
        <div style={{margin:'10px'}} >
    
      
            {this.renderToast()}

            <div class="alert alert-dismissible alert-primary">
            <div className="row">

                    <div className='col'> 
                        <h3 >SEND SHIPMENT REQUEST TO CLIENT</h3>
                        <br/>
                        <h6>{this.state.name}</h6>
                    </div>
                    
                    
                    
            </div>

          

        </div>
        

        <div className="row">
            <div className='col'>
                      <h5>  FROM </h5>


                        <div className="form-row">
                                <div className="col">
                                  <h5> {this.state.name} </h5>
                                  {this.state.fromAddress + ' ' + this.state.fromAddress2}
                                  <br/>
                                  {this.state.fromCity + ' ' + this.state.fromState + '. ' + this.state.fromPostalCode}
                                  <br/>
                                  {this.state.fromCountry}
                                  </div>
                                </div>
                              
                       
                               
                         </div>
            
            
            
            
            
                    <div className='col'>
                   <h5> TO: </h5>
                   
                   <div className="form-row">
                                <div className="col">
                                <div className="col">
                                  <h5> {this.props.claim.firstName + ' ' + this.props.claim.lastName}</h5> 
                                  {this.state.toAddress + ' ' + this.state.toAddress2}
                                  <br/>
                                  {this.state.toCity + ' ' + this.state.toState + '. ' + this.state.toPostalCode}
                                  <br/>
                                  {this.state.toCountry}
                                  </div>
                                </div>

                    </div>
                           
                               
                        

            </div>

                       

        </div>
         <hr/>
         <div class="alert alert-dismissible alert-primary">
            <div className="row">

                    <div className='col'> 
                        <h3 >Package Dimensions</h3>
                        <br/>
                        
                    </div>
                    
                    
                    
            </div>
            <div className='form-row'>
                    <div className='col-3'>
                        <label htmlFor="shippingPostalCode"> Width (inches):</label>
                        <input
                        disabled={this.state.disabled}
                        type="numeric"
                        onChange={this.handleInputChange}
                        name="widthInInches"
                        className="form-control"
                        placeholder=""

                        value= {this.state.widthInInches}
                        />   
                    </div>
                    <div className='col-3'>
                        <label htmlFor="shippingPostalCode"> Height (inches):</label>
                        <input
                        disabled={this.state.disabled}
                        type="numeric"
                        onChange={this.handleInputChange}
                        name="heightInInches"
                        className="form-control"
                        placeholder=""

                        value= {this.state.heightInInches}
                        />   
                    </div>
                    <div className='col-3'>
                        <label htmlFor="shippingPostalCode"> Length (inches):</label>
                        <input
                        disabled={this.state.disabled}
                        type="numeric"
                        onChange={this.handleInputChange}
                        name="lengthInInches"
                        className="form-control"
                        placeholder=""

                        value= {this.state.lengthInInches}
                        />   
                    </div>
                    <div className='col-3'>
                        <label htmlFor="shippingPostalCode"> Weight (ounces):</label>
                        <input
                        disabled={this.state.disabled}
                        type="numeric"
                        onChange={this.handleInputChange}
                        name="weightInOunces"
                        className="form-control"
                        placeholder=""

                        value= {this.state.weightInOunces}
                        />   
                    </div>


            </div>
</div>
         <div className='row'>
              
              <div className='col text-center'>
               <h5> Sending to: {this.props.claim.email} </h5>
               </div>
         </div>
         <div className='row'>
              
              <div className='col text-center'>

         <button
                        disabled={this.state.disabled}
                        className="btn btn-success"
                        onClick={() => {this.sendShipRequest()}}>
                        Send payment and shipping request to client
                      </button>
                      </div>
         </div>   


        </div>


      )  



    }
}

export default withRouter(ClaimShipment); 


